import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {LogFile} from '../../models/log/logfile';
const apiUrl = `${environment.apiUrl}/api/logfile`;

@Injectable({
  providedIn: 'root'
})
export class LogFileService {
  constructor(public httpService: HttpClient) { }

  findAllByClassPkAndNam(className: String, pkId: number): Observable<LogFile[]> {
    return this.httpService.get<LogFile[]>(`${apiUrl}/getallbypkidandclass?cn=${className}&pk=${pkId}`).pipe(
      map(data => data.map( data => new LogFile().deserialize(data)))
    );
  }
}
